// src/main.js
import { supabaseClient } from './conection/supabaseClient.js';
import {
    limparNumeros,
    validarCPF,
    validarCNPJ,
    formatarTelefoneInput,
    formatarCPFInput,
    formatarCNPJInput
} from './utils/utils.js';

document.addEventListener('DOMContentLoaded', () => {
    // --- Inicialização do Swiper ---
    try {
        const swiper = new Swiper('.swiper-container', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
        });
    } catch (e) {
        console.warn("Swiper não pôde ser inicializado. Verifique se a biblioteca está carregada e o container existe.", e);
    }

    // --- Elementos do Formulário ---
    const cadastroForm = document.getElementById('cadastro-form');
    const nomeInput = document.getElementById('nome');
    const telefoneInput = document.getElementById('telefone');
    const telefoneInvalidoDiv = document.getElementById('telefone-invalido');
    const cpfInput = document.getElementById('cpf');
    const cpfInvalidoDiv = document.getElementById('cpf-invalido');
    const empresaInput = document.getElementById('empresa');
    const cnpjInput = document.getElementById('cnpj');
    const cnpjInvalidoDiv = document.getElementById('cnpj-invalido');
    const emailInput = document.getElementById('email');
    const emailInvalidoDiv = document.getElementById('email-invalido');
    const termosCheckbox = document.getElementById('termos-lgpd');
    const termosInvalidoDiv = document.getElementById('termos-invalido');
    const gravarCadastroButton = document.getElementById('gravar-cadastro');
    const mensagemCadastroDiv = document.getElementById('mensagem-cadastro');
    const comoSoubeSelect = document.getElementById('como-soube');
    const comoSoubeInvalidoDiv = document.getElementById('como-soube-invalido');
    const comoSoubeOutroContainer = document.getElementById('como-soube-outro-container');
    const comoSoubeOutroInput = document.getElementById('como-soube-outro');
    const comoSoubeOutroInvalidoDiv = document.getElementById('como-soube-outro-invalido');
    //const tipoParticipanteSelect = document.getElementById('tipo-participante'); // INCORRETO
    const tipoParticipanteRadios = document.querySelectorAll('input[name="tipo-participante"]');
    const tipoParticipanteInvalidoDiv = document.getElementById('tipo-participante-invalido');
    const representanteRadios = document.querySelectorAll('input[name="representante"]');

    // --- Elementos da Modal de Sucesso ---
    const successModalOverlay = document.getElementById('success-modal-overlay');
    const successModalBox = document.getElementById('success-modal-box');
    const successModalOkBtn = document.getElementById('success-modal-ok-btn');
    // --- Fim Elementos Modal ---

    // --- Listeners de Formatação e Validação ---
    // Formatação e validação de Telefone
    telefoneInput?.addEventListener('input', (e) => {
        e.target.value = formatarTelefoneInput(e.target.value);
        if (telefoneInvalidoDiv) telefoneInvalidoDiv.style.display = 'none';
    });
    telefoneInput?.addEventListener('blur', (e) => {
        const tel = limparNumeros(e.target.value);
        if (telefoneInvalidoDiv) {
            if (tel && (tel.length < 10 || tel.length > 11)) {
                telefoneInvalidoDiv.textContent = 'Celular inválido (10 ou 11 dígitos).';
                telefoneInvalidoDiv.style.display = 'block';
            } else {
                telefoneInvalidoDiv.style.display = 'none';
            }
        }
    });

    // Formatação e validação de CPF
    cpfInput?.addEventListener('input', (e) => {
        e.target.value = formatarCPFInput(e.target.value);
        if (cpfInvalidoDiv) cpfInvalidoDiv.style.display = 'none';
    });
    cpfInput?.addEventListener('blur', (e) => {
        const cpf = limparNumeros(e.target.value);
        if (cpfInvalidoDiv) {
            if (cpf && !validarCPF(cpf)) {
                cpfInvalidoDiv.textContent = 'CPF inválido.';
                cpfInvalidoDiv.style.display = 'block';
            } else {
                cpfInvalidoDiv.style.display = 'none';
            }
        }
    });

    // Formatação e validação de CNPJ
    cnpjInput?.addEventListener('input', (e) => {
        e.target.value = formatarCNPJInput(e.target.value);
        if (cnpjInvalidoDiv) cnpjInvalidoDiv.style.display = 'none';
    });
    cnpjInput?.addEventListener('blur', (e) => {
        const cnpj = limparNumeros(e.target.value);
        if (cnpjInvalidoDiv) {
            if (cnpj && !validarCNPJ(cnpj)) {
                cnpjInvalidoDiv.textContent = 'CNPJ inválido.';
                cnpjInvalidoDiv.style.display = 'block';
            } else {
                cnpjInvalidoDiv.style.display = 'none';
            }
        }
    });

    // Limpar erro de Email ao digitar
    emailInput?.addEventListener('input', () => {
        if (emailInvalidoDiv) emailInvalidoDiv.style.display = 'none';
    });

    // Limpar erro dos Termos ao marcar
    termosCheckbox?.addEventListener('change', () => {
        if (termosCheckbox?.checked && termosInvalidoDiv) {
            termosInvalidoDiv.style.display = 'none';
        }
    });

    // Mostrar/ocultar campo "Outro" de "Como soube"
    comoSoubeSelect?.addEventListener('change', () => {
        const showOutro = comoSoubeSelect.value === 'Outro';
        if (comoSoubeOutroContainer) {
            comoSoubeOutroContainer.style.display = showOutro ? 'block' : 'none';
        }
        if (comoSoubeOutroInput) {
            comoSoubeOutroInput.required = showOutro;
            if (!showOutro) {
                comoSoubeOutroInput.value = '';
                if (comoSoubeOutroInvalidoDiv) comoSoubeOutroInvalidoDiv.style.display = 'none';
            }
        }
        if (comoSoubeInvalidoDiv) comoSoubeInvalidoDiv.style.display = 'none';
    });

    // --- Evento de Gravar Cadastro ---
    gravarCadastroButton?.addEventListener('click', async () => {
        // Resetar estado de erro
        const errorDivs = [
            telefoneInvalidoDiv, cpfInvalidoDiv, cnpjInvalidoDiv,
            emailInvalidoDiv, termosInvalidoDiv, comoSoubeInvalidoDiv,
            comoSoubeOutroInvalidoDiv, tipoParticipanteInvalidoDiv
        ];
        errorDivs.forEach(div => { if (div) div.style.display = 'none'; });
        if (mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = '';
            mensagemCadastroDiv.style.color = 'black';
        }

        // Coleta os dados
        const nome = nomeInput?.value.trim() || '';
        const telefoneRaw = limparNumeros(telefoneInput?.value);
        const cpfRaw = limparNumeros(cpfInput?.value);
        const empresa = empresaInput?.value.trim() || '';
        const cnpjRaw = limparNumeros(cnpjInput?.value);
        const email = emailInput?.value.trim() || '';
        const comoSoube = comoSoubeSelect?.value || '';
        const comoSoubeOutro = comoSoubeOutroInput?.value.trim() || '';
        const termosAceitos = termosCheckbox?.checked || false;
        //const tipoParticipante = tipoParticipanteSelect?.value || ''; // INCORRETO
        let tipoParticipante = '';
        tipoParticipanteRadios.forEach(radio => {
            if (radio.checked) {
                tipoParticipante = radio.value;
            }
        });

        let representante = null;
        representanteRadios.forEach(radio => {
            if (radio.checked) {
                representante = radio.value === 'true';
            }
        });

        // --- Validações ---
        let hasError = false;
        let errorMessages = [];

        if (!nome) errorMessages.push('Nome é obrigatório.');
        if (!telefoneRaw) {
            errorMessages.push('Celular é obrigatório.');
        } else if (telefoneRaw.length < 10 || telefoneRaw.length > 11) {
            if (telefoneInvalidoDiv) {
                telefoneInvalidoDiv.textContent = 'Celular inválido (10 ou 11 dígitos).';
                telefoneInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!email) {
            errorMessages.push('Email é obrigatório.');
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                if (emailInvalidoDiv) {
                    emailInvalidoDiv.textContent = 'Formato de email inválido.';
                    emailInvalidoDiv.style.display = 'block';
                }
                hasError = true;
            }
        }
        if (cpfRaw && !validarCPF(cpfRaw)) {
            if (cpfInvalidoDiv) {
                cpfInvalidoDiv.textContent = 'CPF inválido.';
                cpfInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (cnpjRaw && !validarCNPJ(cnpjRaw)) {
            if (cnpjInvalidoDiv) {
                cnpjInvalidoDiv.textContent = 'CNPJ inválido.';
                cnpjInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!comoSoube) {
            if (comoSoubeInvalidoDiv) {
                comoSoubeInvalidoDiv.textContent = 'Selecione como ficou sabendo da feira.';
                comoSoubeInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        } else if (comoSoube === 'Outro' && !comoSoubeOutro) {
            if (comoSoubeOutroInvalidoDiv) {
                comoSoubeOutroInvalidoDiv.textContent = 'Por favor, especifique qual outro meio.';
                comoSoubeOutroInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!termosAceitos) {
            if (termosInvalidoDiv) termosInvalidoDiv.style.display = 'block';
            hasError = true;
        }
        if (!tipoParticipante) {
            if (tipoParticipanteInvalidoDiv) tipoParticipanteInvalidoDiv.style.display = 'block';
            hasError = true;
        }

        // Exibe erros gerais
        if (errorMessages.length > 0 && mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = errorMessages.join(' ');
            mensagemCadastroDiv.style.color = 'red';
            hasError = true;
        }

        // Interrompe se houver erro
        if (hasError) return;

        // Desabilita botão e mostra mensagem de processamento
        if (gravarCadastroButton) gravarCadastroButton.disabled = true;
        if (mensagemCadastroDiv) {
            mensagemCadastroDiv.textContent = 'Verificando dados...';
            mensagemCadastroDiv.style.color = 'black';
        }

        // --- Lógica de Submissão ---
        try {
            // 1. Verifica Duplicidade
            const checks = [];
            checks.push(supabaseClient.from('participantes').select('id', { count: 'exact' }).eq('telefone', telefoneRaw));
            checks.push(supabaseClient.from('participantes').select('id', { count: 'exact' }).eq('email', email));
            if (cpfRaw) {
                checks.push(supabaseClient.from('participantes').select('id', { count: 'exact' }).eq('cpf', cpfRaw));
            }
            // if (cnpjRaw) { checks.push(...); }

            const results = await Promise.all(checks);

            if (results[0]?.data?.length > 0) throw new Error('Este Celular já está cadastrado.');
            if (results[1]?.data?.length > 0) throw new Error('Este Email já está cadastrado.');
            if (cpfRaw && results[2]?.data?.length > 0) throw new Error('Este CPF já está cadastrado.');
            // if (cnpjRaw && results[3]?.data?.length > 0) throw new Error('Este CNPJ já está cadastrado.');

            // 2. Inserção no Banco
            if (mensagemCadastroDiv) mensagemCadastroDiv.textContent = 'Gravando...';

            const { data: newParticipant, error: insertError } = await supabaseClient
                .from('participantes')
                .insert([{
                    nome: nome,
                    telefone: telefoneRaw,
                    cpf: cpfRaw || null,
                    empresa: empresa || null,
                    cnpj: cnpjRaw || null,
                    email: email,
                    aceitou_termos: termosAceitos,
                    como_soube: comoSoube,
                    como_soube_outro: (comoSoube === 'Outro' ? comoSoubeOutro : null),
                    tipo_participante: tipoParticipante,
                    representante: representante
                }])
                .select()
                .single();

            if (insertError) throw insertError;

            // 3. Sucesso
            if (cadastroForm) cadastroForm.reset();
            if (termosCheckbox) termosCheckbox.checked = false;
            if (comoSoubeOutroContainer) comoSoubeOutroContainer.style.display = 'none';
            if (comoSoubeOutroInput) comoSoubeOutroInput.required = false;

            showSuccessModal();

            if (nomeInput) nomeInput.focus();

        } catch (error) {
            // 4. Tratamento de Erro
            if (mensagemCadastroDiv) {
                mensagemCadastroDiv.textContent = `Erro: ${error.message || 'Não foi possível realizar o cadastro.'}`;
                mensagemCadastroDiv.style.color = 'red';
            }
        } finally {
            // 5. Reabilita o Botão
            if (gravarCadastroButton) gravarCadastroButton.disabled = false;
        }
    }); // Fim do listener do botão gravar
    // --- Funções da Modal de Sucesso ---
    function showSuccessModal() {
        if (successModalOverlay) {
            if (mensagemCadastroDiv) mensagemCadastroDiv.textContent = '';
            successModalOverlay.classList.add('visible');
        } else {
            // Fallback para a mensagem antiga caso a modal não exista
            if (mensagemCadastroDiv) {
                mensagemCadastroDiv.textContent = 'Cadastro realizado com sucesso!';
                mensagemCadastroDiv.style.color = 'green';
            }
        }
    }

    function hideSuccessModal() {
        if (successModalOverlay) {
            successModalOverlay.classList.remove('visible');
            // Opcional: Focar no primeiro campo de novo após fechar a modal
            if (nomeInput) nomeInput.focus();
        }
    }

    // Listener para o botão OK da modal de sucesso
    successModalOkBtn?.addEventListener('click', hideSuccessModal);

    // Opcional: Fechar a modal clicando fora da caixa (no overlay)
    successModalOverlay?.addEventListener('click', (event) => {
        if (event.target === successModalOverlay) {
            hideSuccessModal();
        }
    });

    // Opcional: Fechar a modal com a tecla Escape
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && successModalOverlay?.classList.contains('visible')) {
            hideSuccessModal();
        }
    });
    // --- Fim Funções Modal ---

    // --- Lógica da Modal de Termos (Existente) ---
    const termosModal = document.getElementById('termos-modal');
    const modalTriggers = document.querySelectorAll('.modal-trigger');
    // ... (restante da lógica da modal de termos)
}); // Fim do DOMContentLoaded